import styled from "@emotion/styled";
import { useCallback, useState, type HTMLAttributes } from "react";

import { Icon } from "../icons";
import { PropertiesPanelPopoverContent } from "../panels";
import { Popover } from "../popup";
import { zIndexes } from "../utilities";
import { FieldPaletteInputs } from "./FieldPaletteInputs";
import { ThemePaletteVisualiser } from "./ThemePaletteVisualiser";
import type { PlayerPalette } from "./types";

export type ThemePalettePickerProps = HTMLAttributes<HTMLDivElement> & {
  onChange: (value: PlayerPalette) => void;
  value: PlayerPalette;
  onResetToOriginalConfig?: () => void;
  label?: string;
  helperText?: React.ReactNode;
  onChangeCommitted?: () => void;
};

export const ThemePalettePicker = ({
  // onResetToOriginalConfig,
  label,
  // onChangeCommitted,
  value,
  id,
}: ThemePalettePickerProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  // const formatMessage = useFormatMessage(formatStrings);

  const handlePopoverClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl],
  );

  const handlePopoverClose = useCallback(() => {
    setAnchorEl(null);
  }, [setAnchorEl]);

  // const handleResetClicked = useCallback(() => {
  //   onResetToOriginalConfig?.();
  //   onChangeCommitted?.();
  // }, [onResetToOriginalConfig, onChangeCommitted]);

  const open = Boolean(anchorEl);

  return (
    <>
      <ClickableRow aria-describedby={`themePalettePicker-${id}`} onClick={handlePopoverClick}>
        <ThemePaletteVisualiser title={label ?? ""} palette={value} />
        <Icon icon={open ? "angle-left" : "angle-right"} />
      </ClickableRow>

      <StyledPopover
        id={`themePalettePicker-${id}`}
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 10,
          horizontal: -18,
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
      >
        <PropertiesPanelPopoverContent
          onClose={handlePopoverClose}
          header={
            <>
              {/*
                // TODO: we may want this "reset" palette button back.
              <Tooltip title={formatMessage("resetToDefaultTooltip")} placement="top-end">
                <IconButton onClick={handleResetClicked} data-test="reset-button">
                  <Icon icon="history" />
                </IconButton>
              </Tooltip> */}
              {label}
            </>
          }
        >
          <FieldPaletteInputs />
        </PropertiesPanelPopoverContent>
      </StyledPopover>
    </>
  );
};

const ClickableRow = styled.div`
  cursor: pointer;
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
  width: 100%;
  gap: 10px;
`;

const StyledPopover = styled(Popover)`
  z-index: ${zIndexes.propertiesPanelPopover};

  .MuiPaper-root {
    overflow: visible;
    border-radius: 8px;
  }
`;

// const formatStrings = {
//   resetToDefaultTooltip: {
//     en: "Reset to Default",
//   },
// };
